export default __webpack_public_path__ + "static/media/P104.3.3f29ef84.mp3";